import { CraftIdentityContext } from 'pages/CraftIdentity';
import { CraftPredictionContext } from 'pages/CraftPrediction';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import CraftFilterItemScrollable from './CraftFilterItemScrollable';
import { useSoundPath } from 'hooks/useSoundPath';

const CraftFilterItem = ({ queryValue, filter, openedFilter, setOpenedFilter }) => {
  const { pathname } = useLocation();
  const getContext = pathname.includes('identity') ? CraftIdentityContext : CraftPredictionContext;
  const { activeFilters, setActiveFilters } = useContext(getContext);
  const { name } = filter;
  const playSound = useSoundPath();

  if (openedFilter !== null) {
    window.addEventListener('click', () => setOpenedFilter(null));
  }

  const isActiveFilter = (value) => {
    const filter = activeFilters.find(filter => filter.queryValue === queryValue);
    return filter && filter.value.split(',').includes(value) ? 'active' : '';
  };

  const activeFiltersHandle = (value) => {
    setActiveFilters(prevActiveFilters => {
      const existingFilter = prevActiveFilters.find(filter => filter.queryValue === queryValue);
      if (existingFilter) {
        const currentValues = existingFilter.value.split(',');
        if (currentValues.includes(value)) {
          const updatedValues = currentValues.filter(val => val !== value);
          return prevActiveFilters.map((filter) =>
            filter.queryValue === queryValue
              ? { ...filter, value: updatedValues.join(',') }
              : filter
          );
        } else {

          const newValue = existingFilter.value ? `${existingFilter.value},${value}` : value;
          return prevActiveFilters.map((filter) =>
            filter.queryValue === queryValue
              ? { ...filter, value: newValue }
              : filter
          );
        }
      } else {
        return [...prevActiveFilters, { queryValue, value }];
      }
    });
  };

  const clearFilter = () => {
    setActiveFilters(prevFilters =>
      prevFilters.filter(filter => filter.queryValue !== queryValue)
    );
    setOpenedFilter(null);
  };

  const sortedItems =
  filter.filter !== null && Array.isArray(filter.filter)
    ? filter.name === 'Rarities'
      ? filter.filter
      : filter.filter.sort((a, b) => a.name.localeCompare(b.name))
    : [];

  if (sortedItems.length === 0) return null;

  return (
    <div className="craft-select__form-popup-wrapper" onClick={(e) => e.stopPropagation()}>
      <button
        className={`craft-select__form-filter ${openedFilter === name ? 'active' : ''}`}
        type='button'
        onClick={() => {
          if (openedFilter === name) {
            setOpenedFilter(null);
            playSound('closeSubmenu')
          } else {
            setOpenedFilter(name);
            playSound('openSubmenu')
          }
        }}
      >
        {name}
      </button>
      <CraftFilterItemScrollable
        sortedItems={sortedItems}
        isActiveFilter={isActiveFilter}
        activeFiltersHandle={activeFiltersHandle}
        clearFilter={clearFilter} />
    </div>
  );
};

export default CraftFilterItem;
